import TimelineCircleImage from '../../../../timeline/TimelineCircleImage/TimelineCircleImage';

const Image = require('../../../../../assets/img/timeline/modal/1998-cap.jpg');

const CapContent = () => {
    return (
        <>
            <TimelineCircleImage image={Image} />
            <h4>
                The Consumer Advisory Panel
            </h4>
            <p>
            The Consumer Advisory Panel (CAP) is established – the first of its kind in Australia – recognising the value and importance of consumer input into the planning and conduct of clinical trials research. Adjunct Professor Linda Reaby was the first CAP Chair. The input and insights provided by CAP members, most of whom have participated in one of our clinical trials, are integral to the Breast Cancer Trials research program. 
            </p>
        </>
    );
}

export default CapContent;